// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, "@media (min-width:768px){.aU1BoqqU85R1jtsqP-6c1A\\=\\={aspect-ratio:1}}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"aspectRatio": "aU1BoqqU85R1jtsqP-6c1A=="
};
module.exports = ___CSS_LOADER_EXPORT___;
